import Head from 'next/head';
import {ReactNode} from 'react';
import {useDispatch} from 'react-redux';
import FloatingDevBox from './FloatingDevBox';
import Auth from '../../auth/container/Auth';
import IdVerificationModal from '../../auth/container/IdVerificationModal';
import {ActionType as AuthActionType} from '../../auth/state/action';
import {actions as authActions} from '../../auth/state/action';
import MaxWidth from '../../commonSub/component/MaxWidth';
import {ActionType} from '../../commonSub/state/action';
import Loading from '../component/Loading';
import MaintenencePopup from '../component/MaintenancePopup';
import {
  ROOT_ELEMENT_ID,
  IS_CLIENT,
  ENV_NAME,
  IS_CBT_OR_PROD,
  IS_LOCAL,
} from '../constant';
import useEffectAfterTrue from '../hook/useEffectAfterTrue';
import useTypedSelector from '../hook/useTypedSelector';
import {useFetchInfo} from '../util/fetch';

interface IProps {
  isFullWidth?: boolean;
  children?: ReactNode;
}

export default function Layout({isFullWidth, children}: IProps) {
  const dispatch = useDispatch();
  const [
    isPageLoading,
    isAppMounted,
    isPageLoadingSlow,
    showFullLoadingCount,
    totalAlert,
    maintenancePopup,
  ] = useTypedSelector(state => [
    state.common.isPageLoading,
    state.common.isAppMounted,
    state.common.isPageLoadingSlow,
    state.common.showFullLoadingCount,
    state.common.pAlerts.length,
    state.commonSub.maintenancePopup,
  ]);
  const {isSlow: isFetchUseTicketSlow} = useFetchInfo(
    ActionType.FetchUseTicket
  );
  const {isSlow: isFetchFinishSlow} = useFetchInfo(AuthActionType.FetchFinish);
  const isClosedContinueLogin = useTypedSelector(
    state => state.auth.isClosedContinueLogin
  );
  useEffectAfterTrue(() => {
    dispatch(authActions.setValue('isClosedContinueLogin', false));
  }, !!isClosedContinueLogin);

  return (
    // 아래 id 값은 react-modal 에서 사용된다.
    <div id={ROOT_ELEMENT_ID} className="h-full">
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, shrink-to-fit=no"
        />
        {/* for PWA */}
        <link rel="manifest" href="/manifest.json" />
        {IS_CBT_OR_PROD ? (
          <link
            rel="shortcut icon"
            href="/ico/icon76_210521.png"
            type="image/x-icon"
          />
        ) : (
          <link
            rel="shortcut icon"
            href={getDevelopmentFavicon()}
            type="image/png"
          />
        )}
        {/*
          - for android 4.X 버전을 위해 남겨둔다
          - 참고: https://caniuse.com/#search=manifest
        */}
        <link rel="icon" href="/ico/icon192_210521.png" sizes="192x192" />
        {/* for ios */}
        <link
          rel="apple-touch-icon"
          href="/ico/icon180_210521.png"
          sizes="180x180"
        />
        {/* TODO: splash 이미지 추가, dev favicon처럼 동적으로 만들어보자. */}
      </Head>
      <Loading
        show={
          ((isPageLoading && !isAppMounted) ||
            isPageLoadingSlow ||
            isFetchFinishSlow ||
            !!showFullLoadingCount ||
            isFetchUseTicketSlow) &&
          !totalAlert
        }
        isFull={true}
      />
      <main className="h-full pt-0">
        <MaxWidth className="h-full relative" disabled={isFullWidth}>
          {maintenancePopup ? (
            <MaintenencePopup {...maintenancePopup} />
          ) : (
            children
          )}
        </MaxWidth>
      </main>
      <Auth />
      <IdVerificationModal />
      {IS_LOCAL && <FloatingDevBox />}
    </div>
  );
}

function getDevelopmentFavicon() {
  if (IS_CLIENT) {
    const text = ENV_NAME === 'dev' ? 'D' : 'L';
    const cvs = document.createElement('canvas');
    const context = cvs.getContext('2d');
    cvs.width = 32;
    cvs.height = 32;
    if (context) {
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, 32, 32);
      context.font = '24px Arial';
      context.fillStyle = '#000000';
      context.fillText(text, 7, 24);
    }
    return cvs.toDataURL('image/png');
  }
  return '';
}
